import type { Locale } from "../api/types";
import { chromeLocale } from "../lib/locale-context";

/**
 * The "System (" network-filter warning (ruling 10 Oct 2026, afternoon). Thai is provisional, kept beside English like
 * every chrome dictionary; the screen renders English for everyone (`chromeLocale`, ruling 2026-09-17).
 */
const EN = {
  hint: "This text may be blocked by the network filter: “System (”.",
  fix: "Use “System – (”",
  fixed: "Changed to “System – (”.",
  proxyBlocked:
    "The network filter refused this save. This usually happens when the text contains “System (”. Change it to “System – (” and try again.",
};

export type SystemParenTextKey = keyof typeof EN;

export const SYSTEM_PAREN_TEXT: Record<Locale, Record<SystemParenTextKey, string>> = {
  en: EN,
  th: {
    hint: "ข้อความนี้อาจถูกตัวกรองเครือข่ายบล็อก: “System (”",
    fix: "ใช้ “System – (”",
    fixed: "เปลี่ยนเป็น “System – (” แล้ว",
    proxyBlocked:
      "ตัวกรองเครือข่ายปฏิเสธการบันทึกนี้ มักเกิดเมื่อข้อความมี “System (” ให้เปลี่ยนเป็น “System – (” แล้วลองอีกครั้ง",
  },
};

export function systemParenText(key: SystemParenTextKey, locale: Locale | undefined): string {
  return SYSTEM_PAREN_TEXT[chromeLocale(locale)][key];
}
